import { useState } from 'react';
import { ArrowLeft, EllipsisVertical } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function MobileHeaderNavigation({ title, onBack, menuItems }) {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className="mobile-only md:hidden bg-background border-b border-border sticky top-0 z-40">
            <div className="px-[20px] py-[16px] flex items-center justify-between">
                <Button
                    variant="plain"
                    color="neutral"
                    size="auto"
                    onClick={onBack}
                    className="w-[36px] h-[36px] bg-muted rounded-full flex items-center justify-center hover:bg-border transition-colors"
                >
                    <ArrowLeft className="h-5 w-5 text-foreground" />
                </Button>

                <h1 className="text-[16px] text-foreground font-medium">{title}</h1>

                {menuItems?.length > 0 ? (
                    <div className="relative">
                        <Button
                            variant="plain"
                            color="neutral"
                            size="auto"
                            onClick={() => setMenuOpen(!menuOpen)}
                            className="w-[36px] h-[36px] bg-muted rounded-full flex items-center justify-center hover:bg-border transition-colors"
                        >
                            <EllipsisVertical className="h-5 w-5 text-foreground" />
                        </Button>

                        {menuOpen && (
                            <>
                                <div className="fixed inset-0 z-40" onClick={() => setMenuOpen(false)} />
                                <div className="absolute right-0 top-11 bg-card rounded-xl shadow-lg border border-border py-2 w-[200px] z-50">
                                    {menuItems.map((item, i) => (
                                        <Button
                                            key={i}
                                            variant="plain"
                                            color="neutral"
                                            onClick={() => {
                                                setMenuOpen(false);
                                                item.onClick();
                                            }}
                                            className="w-full h-auto px-4 py-3 text-left justify-start rounded-none hover:bg-muted transition-colors"
                                        >
                                            <span
                                                className={`text-[14px] ${item.danger ? 'text-destructive' : 'text-foreground'}`}
                                            >
                                                {item.label}
                                            </span>
                                        </Button>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                ) : (
                    <div className="w-[36px] h-[36px]" />
                )}
            </div>
        </div>
    );
}
